import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { BillingDTO } from "../../../../../store/billing/models/dto";
import { Confirm } from "./confirm";
import { Purchase } from "./purchase";

type FormProps = {
  chain?: BillingDTO.Responses.GetSKRTAddresses.T[number];
  amount: number;
};

export const Manual: FC<FormProps> = ({ amount, chain }) => {
  const [purchaseID, setPurchaseID] = useState<string>();
  const { t } = useTranslation("billing");

  if (chain === undefined)
    return <div>{t("destination-wallet-unavailable")}</div>;

  return purchaseID === undefined ? (
    <Purchase chain={chain} amount={amount} proceed={setPurchaseID} />
  ) : (
    <Confirm chain={chain} purchaseID={purchaseID} />
  );
};
